import {IKycVerificationResponse} from "../../../app/modules/kyc/IKycVerificationResponse";
import {ICompanyKycRequest} from "../../../app/modules/kyc/company/interfaces/ICompanyKycRequest";
import {IPersonKycRequest} from "../../../app/modules/kyc/person/interfaces/IPersonKycRequest";

export const KYC_VERIFICATION_CONSTANTS = {
    RESET: "RESET",
    FETCH_LOADING: "FETCH_LOADING",
    STOP_FETCH: "STOP_FETCH",
    FETCH_STATUS: "FETCH_STATUS",
    REQUEST_DETAILS: "REQUEST_DETAILS",
    INITIATE_REQUEST: "INITIATE_REQUEST",
    IDV_INPROGRESS: "IDV_INPROGRESS",
    PNV_INPROGRESS: "PNV_INPROGRESS",
    TNV_INPROGRESS: "TNV_INPROGRESS",
    EMAIL_INPROGRESS: "EMAIL_INPROGRESS",
    BNV_INPROGRESS: "BNV_INPROGRESS",
    KCCA_INPROGRESS: "KCCA_INPROGRESS",
    AML_INPROGRESS: "AML_INPROGRESS",
    AMLPEP_INPROGRESS: "AMLPEP_INPROGRESS"
}

export interface IVerificationState {
    loading: boolean
    response?: IKycVerificationResponse
    request?: ICompanyKycRequest | IPersonKycRequest | undefined
}

const initialState: IVerificationState = {
    loading: false,
    response: undefined,
    request: undefined,
}

export default function reducer(state = initialState, action: any) {
    switch (action.type) {

        case KYC_VERIFICATION_CONSTANTS.FETCH_LOADING: {
            return {...state, loading: action.payload}
        }

        case KYC_VERIFICATION_CONSTANTS.REQUEST_DETAILS: {
            const segments = window.location.pathname.split('/')
            const ID =  segments.pop() || segments.pop();
            if (action.payload.profileId) {
                if (action.payload.profileId !== ID) {
                    return {...state}
                }
                
            }
            return {...state, response: action.payload}
        }

        case KYC_VERIFICATION_CONSTANTS.INITIATE_REQUEST: {
            return {...state, request: action.payload, response: undefined}
        }

        case KYC_VERIFICATION_CONSTANTS.IDV_INPROGRESS: {
            const idvInProgress = {status: 'Pending'}
            if (state.response?.identityDocumentChecks) {
                state.response?.identityDocumentChecks.push(idvInProgress)
            }
            return {...state}
        }

        case KYC_VERIFICATION_CONSTANTS.PNV_INPROGRESS: {
            const pnvInProgress = {status: 'Pending'}
            if (state.response?.phoneNumberChecks) {
                state.response?.phoneNumberChecks.push(pnvInProgress)
            }
            return {...state}
        }

        case KYC_VERIFICATION_CONSTANTS.TNV_INPROGRESS: {
            const tnvInProgress:any = {response: {status: 'Pending'}, status: 'inProgress'}
            if (state.response?.tinChecks?.length) {
                state.response.tinChecks.push(tnvInProgress)
            }

            if (state.response?.tinChecks.length === 0) {
                state.response.tinChecks.push(tnvInProgress)
            }
            return {...state}
        }

        case KYC_VERIFICATION_CONSTANTS.EMAIL_INPROGRESS: {
            const emailInProgress:any = {status: 'Pending'}
            if (state.response?.emailChecks) {
                state.response?.emailChecks.push(emailInProgress)
            }
            return {...state}
        }

        case KYC_VERIFICATION_CONSTANTS.BNV_INPROGRESS: {
            const bnvInProgress:any = {response: {status: 'inProgress'}, status: 'inProgress'}
            if (state.response?.businessNameCheck === null) {
                state.response.businessNameCheck = {...bnvInProgress}
            }
            if (state.response?.businessNameCheck?.registrationNumber) {
                state.response.businessNameCheck = {...state.response.businessNameCheck, ...bnvInProgress}
            }
            return {...state}
        }

        case KYC_VERIFICATION_CONSTANTS.KCCA_INPROGRESS: {
            const kccaInProgress:any = {status: 'Pending'}
            if (state.response?.kccaLicenceChecks) {
                state.response?.kccaLicenceChecks.push(kccaInProgress)
            }
            return {...state, loading: false}
        }

        case KYC_VERIFICATION_CONSTANTS.AML_INPROGRESS: {
            const amlInProgress:any = {response: {status: 'Pending'}, status: 'inProgress'}
            if (state.response) {
                state.response.companyAmlScreeningCheck = {status: 'Pending'}
            }
            return {...state}
        }

        case KYC_VERIFICATION_CONSTANTS.AMLPEP_INPROGRESS: {
            const amlInProgress:any = {response: {status: 'Pending'}, status: 'inProgress'}
            if (state.response) {
                state.response.amlPepScreeningCheck = {status: 'Pending'}
            }

            // if (state.response?.amlPepScreeningCheck.length === 0) {
            //     state.response.amlPepScreeningCheck.push(tnvInProgress)
            // }
            return {...state}
        }

        case KYC_VERIFICATION_CONSTANTS.STOP_FETCH: {
            return {...state, loading: false}
        }

        case KYC_VERIFICATION_CONSTANTS.RESET: {
            return {...state, request: undefined, response: undefined, loading: false}
        }

        default: {
            return state
        }
    }
}
